import { Text } from "@chakra-ui/layout";

function FancyText({ children }) {
  return (
    <Text
      bgGradient="linear(to-t, #12c2e9,#c471ed,#f64f59)"
      bgClip="text"
      fontSize="5xl"
      fontWeight="extrabold"
      display="inline"
    >
      {children}
    </Text>
  );
}

export default FancyText;
